// extracted by mini-css-extract-plugin
module.exports = {"calibration":"ResistanceChart_calibration__7JEyq"};